import { useState } from "react"
import { JobbinInputWhite } from "../../components/jobbinInputWhite"
import { LoadingComponent } from "../../components/loading"
import { JobbinPrimaryButton } from "../../components/primaryButton"
import { useLoading } from "../../context/loading"
import { ForgotPasswordSendCode, ConfirmChangeForgottenPassword } from "./model"
import { useNavigate } from "react-router-dom"
import { sendResetCode, confirmPasswordReset } from "../../services/auth-service"
import { useToast } from "../../context/toast"

export const ForgotPasswordPage = () => {
    const { loading, setLoading } = useLoading()
    const { notify } = useToast()

    const [step, setStep] = useState(0)
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [code, setCode] = useState("")

    const navigate = useNavigate()

    const handleSendCode = async () => {
        if (!email) {
            notify("Emailul este obligatoriu.", "info")
            return
        }

        setLoading(true)

        try {
            const payload: ForgotPasswordSendCode = { email }
            const result = await sendResetCode(payload)

            if (result.success) {
                setStep(1)
            } else {
                notify(result.message || "Eroare la trimiterea codului.", "error")
            }
        } catch (err) {
            console.error(err)
            notify("Eroare la trimiterea codului.", "error")
        } finally {
            setLoading(false)
        }
    }

    const handleResetPassword = async () => {
        if (!password || !code) {
            notify("Completează codul și parola nouă.", "info")
            return
        }

        setLoading(true)

        try {
            const payload: ConfirmChangeForgottenPassword = {
                newPassword: password,
                code,
            }

            const result = await confirmPasswordReset(payload)

            if (result.success) {
                notify("Parola a fost resetată cu succes!", "success")
                navigate("/")
            } else {
                notify(result.message || "Eroare la resetarea parolei.", "error")
            }
        } catch (err) {
            console.error(err)
            notify("Eroare la resetarea parolei.", "error")
        } finally {
            setLoading(false)
        }
    }

    return (
        <div id="login-page" className="bg-figmaLightBg min-h-screen">
            {loading && <LoadingComponent />}

            <div className="grid min-h-screen grid-cols-1 lg:grid-cols-12">
                <div className="col-span-1 lg:col-span-5 flex items-center justify-center px-4 py-8 sm:px-6 md:px-8">
                    <div className="w-full max-w-md">
                        <img
                            className="mt-2 mb-8 w-[140px] sm:w-[170px]"
                            src="/images/jobbin-logo-with-icon.png"
                            alt="Jobbin"
                        />

                        <div className="text-start">
                            <h3 className="text-figmaBlack text-[28px] sm:text-[32px] font-bold">
                                Parola uitata
                            </h3>
                            <p className="mt-2 text-figmaDarkGray font-bold text-sm sm:text-base">
                                Introdu emailul și resetează parola
                            </p>
                        </div>

                        <div className="mt-6">
                            <JobbinInputWhite
                                type="email"
                                iconStart="mail-icon.svg"
                                label="Adresa email"
                                name="email"
                                placeholder="Introduceti adresa de email"
                                onChange={(e) => setEmail((e.target as HTMLInputElement).value)}
                            />
                        </div>

                        {step === 1 && (
                            <>
                                <div className="mt-4">
                                    <JobbinInputWhite
                                        type="text"
                                        iconStart="code.svg"
                                        label="Cod primit"
                                        name="cod"
                                        placeholder="Codul primit prin email"
                                        onChange={(e) => setCode((e.target as HTMLInputElement).value)}
                                    />
                                </div>

                                <div className="mt-4">
                                    <JobbinInputWhite
                                        type="password"
                                        iconStart="locket.svg"
                                        label="Parola noua"
                                        name="parola"
                                        placeholder="Parola dumneavoastra"
                                        onChange={(e) => setPassword((e.target as HTMLInputElement).value)}
                                    />
                                </div>
                            </>
                        )}

                        <div className="mt-8">
                            <JobbinPrimaryButton
                                onClickAction={step === 0 ? handleSendCode : handleResetPassword}
                                text={step === 0 ? "Trimite cod" : "Resetează parola"}
                            />
                        </div>

                        <p
                            className="mt-4 cursor-pointer text-sm sm:text-base font-bold text-figmaBlack"
                            onClick={() => navigate("/")}
                        >
                            Înapoi la logare
                        </p>
                    </div>
                </div>

                <div className="hidden lg:flex lg:col-span-7 bg-figmaWhite items-center justify-center p-8">
                    <img
                        className="max-w-full h-auto"
                        src="/images/jobbin-logo-with-icon.png"
                        alt="Jobbin"
                    />
                </div>
            </div>
        </div>
    )
}